export default __webpack_public_path__ + "static/media/Close.f0519915.svg";